import { lazy, Suspense } from 'react'
import PageMeta from 'src/_shared/components/PageMeta'
import Hero from 'src/pages/VoltNet/components/Hero'

const Branding = lazy(() => import('src/pages/VoltNet/components/Branding'))
const CallToActionSection = lazy(() => import('src/_shared/components/CallToActionSection'))
const Compatibility = lazy(() => import('src/_shared/components/Compatibility'))
const Ecosystem = lazy(() => import('src/pages/VoltNet/components/Ecosystem'))
const Visibility = lazy(() => import('src/pages/VoltNet/components/Visibility'))

export const VoltNet = (): JSX.Element => {
	return (
		<>
			<PageMeta
				title="VoltNet - eRoaming Platform for EV Charging Networks"
				description="VoltNet is a powerful eRoaming platform that connects EV charging networks, enabling seamless charging for drivers and efficient management for operators."
			/>
			<Hero />
			<Suspense fallback={<></>}>
				<Ecosystem />
				<Branding />
				<Visibility />
				<Compatibility page={'VoltNet'} />
				<CallToActionSection />
			</Suspense>
		</>
	)
}
